import { httpService } from '~/Services/Service';

export const listarTipos = (filtros) =>
  httpService.get('/tipo-atendimento/listar', { params: filtros });

export const sugerirCodigo = () =>
  httpService.get('/tipo-atendimento/sugerir-codigo');

export const cadastrarTipo = (data) =>
  httpService.post('/tipo-atendimento/cadastrar', data);

export const atualizarTipo = (data) =>
  httpService.post('/tipo-atendimento/atualizar', data);

export const excluirTipo = (data) =>
  httpService.post('/tipo-atendimento/excluir', data);

export const listarSubTipos = (codAtendimento) =>
  httpService.get('/tipo-atendimento/subtipos/listar', { params: { codAtendimento } });

export const sugerirCodigoSubTipo = (codAtendimento) =>
  httpService.get('/tipo-atendimento/subtipos/sugerir-codigo', { params: { codAtendimento } });

export const cadastrarSubTipo = (data) =>
  httpService.post('/tipo-atendimento/subtipos/cadastrar', data);

export const atualizarSubTipo = (data) =>
  httpService.post('/tipo-atendimento/subtipos/atualizar', data);

export const excluirSubTipo = (data) =>
  httpService.post('/tipo-atendimento/subtipos/excluir', data);
